import { render, staticRenderFns } from "./fetchDomainModal.vue?vue&type=template&id=4476edf7&scoped=true"
import script from "./fetchDomainModal.vue?vue&type=script&lang=js"
export * from "./fetchDomainModal.vue?vue&type=script&lang=js"
import style0 from "./fetchDomainModal.vue?vue&type=style&index=0&id=4476edf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4476edf7",
  null
  
)

export default component.exports